import { BottleIcon } from "../components/BottleIcon";
import { BrandMark } from "../components/BrandMark";
import { SAUCES, SAUCE_TYPES, type SauceType } from "../lib/types";

interface Props {
  sauce: SauceType;
  ratedSauces: Set<SauceType>;
  onPickAnother: () => void;
}

export function AlreadyRatedScreen({ sauce, ratedSauces, onPickAnother }: Props) {
  const meta = SAUCES[sauce];
  const remaining = SAUCE_TYPES.filter((s) => !ratedSauces.has(s));
  const allDone = remaining.length === 0;

  return (
    <main className="shell flex flex-col items-center justify-center px-6 text-center">
      <BrandMark className="mb-10 h-14 w-auto" />

      <BottleIcon
        color={meta.accent}
        label={meta.bottleLabel}
        className="mb-6 h-32 w-auto drop-shadow-[0_8px_14px_rgba(0,0,0,0.5)]"
      />

      <h1 className="text-5xl text-cream">Already got you.</h1>
      <p className="mt-3 max-w-xs text-cream-dim">
        You already rated <span style={{ color: meta.accent }}>{meta.name}</span> on this device.
        {allDone
          ? " You've covered all four — thanks."
          : " Try one of the others while you're here."}
      </p>

      <div className="mt-10 flex w-full max-w-xs flex-col gap-3">
        {!allDone && (
          <button type="button" onClick={onPickAnother} className="pill-btn pill-btn-primary">
            Pick another sauce
          </button>
        )}
        <a
          href="https://www.instagram.com/1976barbecue/"
          target="_blank"
          rel="noopener noreferrer"
          className={allDone ? "pill-btn pill-btn-primary" : "pill-btn pill-btn-ghost"}
        >
          Follow us on Instagram
        </a>
      </div>
    </main>
  );
}
